import type { ItemFiltersType } from '../api/types/itemFilters';
import type { ItemAggregationRequest, ItemRequestModelField } from '../api/types/items';

export const commonQueryKeys = {
  boxes: {
    all: ({ filter }: { filter?: string } = {}) => ['boxes', { filter }],
    details: (boxId: number) => ['boxes', 'details', boxId],
  },
  customFields: {
    all: () => ['customFields'],
    search: (search: string) => ['customFields', search],
    details: (id: number) => [...commonQueryKeys.customFields.all(), 'details', id],
    picklistOptions: (customFieldId: number) => [
      ...commonQueryKeys.customFields.details(customFieldId),
      'picklistOptions',
      customFieldId,
    ],
  },
  estimationSchemes: {
    all: () => ['estimationSchemes'],
    details: (id: number) => [...commonQueryKeys.estimationSchemes.all(), 'details', id],
    estimations: ['estimationSchemes', 'estimations'],
  },
  itemTypes: {
    all: ['itemTypes'],
  },
  itemTypeLevels: {
    all: ['itemTypeLevels'],
    create: ['itemTypeLevels', 'create'],
    delete: ['itemTypeLevels', 'delete'],
    details: (levelId: number) => ['itemTypeLevels', 'details', levelId],
  },
  items: {
    all: ({
      filter,
      limit,
      order,
      hierarchical,
    }: {
      filter?: ItemFiltersType;
      limit?: number;
      order?: string;
      hierarchical?: boolean;
    } = {}) => ['items', { filter, limit, order, hierarchical }],
    aggregations: (request: ItemAggregationRequest) => ['items', 'aggregations', request],
  },
  itemsDataSet: (filter?: ItemFiltersType) => ['itemsDataSet', filter],
  insightsItemsDataSet: (filters?: ItemFiltersType) =>
    filters && Object.keys(filters).length > 0
      ? ['insightsItemsDataSet', { filters }]
      : ['insightsItemsDataSet'],
  itemsBulkFetch: ({
    ids,
    fields,
    filter,
  }: {
    ids: number[];
    fields?: ItemRequestModelField[];
    filter?: ItemFiltersType;
  }) => [
    'itemsBulkFetch',
    {
      ids,
      ...(fields ? { fields } : {}),
      ...(filter ? { filter } : {}),
    },
  ],
  item: (itemId: number) => ['item', itemId],
  itemAncestors: (itemId: number) => ['itemAncestors', itemId],
  itemDescendants: {
    all: (itemIds: number[]) => ['item-descendants', itemIds],
    byIds: (itemIds: number[]) => ['item-descendants', 'by-ids', itemIds],
  },
  itemStatuses: {
    all: () => ['itemStatuses'],
    detail: (itemStatusId: number) => [
      ...commonQueryKeys.itemStatuses.all(),
      'detail',
      itemStatusId,
    ],
  },
  spmCustomFields: {
    all: () => ['spmCustomFields'],
  },
  loggedWorkSummary: (itemId: number) => ['loggedWorkSummary', itemId],
  itemChanges: ({ itemIds }: { itemIds: number[] }) => ['itemChanges', itemIds],
};
